import { translate } from '@jsverse/transloco';
export enum FilterDuration {
    PT15M = 'PT15M',
    PT30M = 'PT30M',
    PT1H = 'PT1H',
    PT2H = 'PT2H',
    PT4H = 'PT4H',
    PT8H = 'PT8H',
    PT12H = 'PT12H',
    PT24H = 'PT24H',
}

export class FilterDurationHelper {
    static getFilterDurationLocale(duration: FilterDuration) {
        switch (duration) {
            case FilterDuration.PT15M:
                return translate('CORE.FILTER_DURATION.PT15M');
            case FilterDuration.PT30M:
                return translate('CORE.FILTER_DURATION.PT30M');
            case FilterDuration.PT1H:
                return translate('CORE.FILTER_DURATION.PT1H');
            case FilterDuration.PT2H:
                return translate('CORE.FILTER_DURATION.PT2H');
            case FilterDuration.PT4H:
                return translate('CORE.FILTER_DURATION.PT4H');
            case FilterDuration.PT12H:
                return translate('CORE.FILTER_DURATION.PT12H');
            case FilterDuration.PT24H:
                return translate('CORE.FILTER_DURATION.PT24H');
            default:
                return duration;
        }
    }
}
